<template>
  <div>
    <QCChartFileUpload></QCChartFileUpload>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const QCChartFileUpload = defineAsyncComponent(() =>
  import("@/components/QCCharts/QCChartFileUpload")
);
export default {
  components: {
    QCChartFileUpload,
  },
};
</script>
